import { render, staticRenderFns } from "./PublisherLocation.vue?vue&type=template&id=f3677394&"
import script from "./PublisherLocation.vue?vue&type=script&lang=js&"
export * from "./PublisherLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports